import { Injectable } from '@angular/core';
import {
	CreateVehicleRoadWorthyCheckDto,
	UpdateVehicleRoadWorthyCheckDto,
	VehicleRoadWorthyCheckListDto,
	VehicleRoadWorthyCheckRecordDto,
	VehicleRoadWorthyChecksAppOptionsDto,
	VehicleRoadWorthyCheckSearchDto,
	VehicleRoadWorthyChecksFilters,
	VehicleRoadWorthyChecksStatsDto,
} from '@splitsecondconnect/ultramarine-shared';

import { BaseRecordResolver } from '../../../../shared/base-classes/base-record.resolver';
import { VehicleRoadWorthyChecksService } from '../vehicle-road-worthy-checks.service';

@Injectable({
	providedIn: 'root',
})
export class VehicleRoadWorthyChecksRecordResolver extends BaseRecordResolver<
	VehicleRoadWorthyCheckRecordDto,
	CreateVehicleRoadWorthyCheckDto,
	UpdateVehicleRoadWorthyCheckDto,
	VehicleRoadWorthyCheckListDto,
	VehicleRoadWorthyChecksStatsDto,
	VehicleRoadWorthyChecksAppOptionsDto,
	VehicleRoadWorthyChecksFilters,
	VehicleRoadWorthyCheckSearchDto
> {
	constructor(
		private _vehicleRoadWorthyChecksService: VehicleRoadWorthyChecksService,
	) {
		super(_vehicleRoadWorthyChecksService);
	}
}
